export const PRICE_ID_BASIC = 'price_1K2H5oAgUeNGj5D4bLMMXlzC';
export const PRICE_ID_GOLD = 'price_1K2HA7AgUeNGj5D4RrYDYy1D';

// URL SHIELD EXTENSION
export const URL_EXTENSION = 'https://chrome.google.com/webstore/detail/data-shield/npejhelagbmmjjhapomlnebiejnbbdak?hl=es'

export const steps_content = [
    {
        number: 1,
        description: 'Recopilamos los datos que rellenaste en el formulario de registro.'
    },
    {
        number: 2,
        description: 'Los procesamos y vendemos por ti en nuestros procedimientos.'
    },
    {
        number: 3,
        description: 'Recibes tu parte del beneficio generado en forma de DSH Tokens.'
    }
]